import { Routes } from "@angular/router";
import { AppGuard } from "./guards/app-guard/app.guard";
import { UnauthorizedComponent } from "./components/unauthorized/unauthorized.component";
import { MsalGuard } from "@azure/msal-angular";
import { UserContextResolver } from "./resolvers/user-and-workpaper-context.resolver";

export const routes: Routes = [
  {
    path: "unauthorized",
    component: UnauthorizedComponent,
  },
  {
    path: "",
    canActivate: [MsalGuard,AppGuard],
    resolve: { userContext: UserContextResolver },
    children: [
      {
        path: "",
        loadChildren: () => import("./components/routes"),
      },
    ],
  },
];

export default routes;
